import React, { useEffect } from "react";
import { useDrop } from "react-dnd";
import { useXarrow } from "react-xarrows";
import { useLoading, Rings } from "@agney/react-loading";
import { delete_step, get_metadata_info, get_step_data } from "./Api";
import { usePopper } from "react-popper";
import "bootstrap/dist/css/bootstrap.css";

import "../../views/styles.css";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { createPortal } from "react-dom";

export const Portal = ({ children }) => {
  return createPortal(children, document.body);
};
export function Content() {
  const { containerProps, indicatorEl } = useLoading({
    loading: true,
    indicator: <Rings width="100" />,
  });

  return <section {...containerProps}>{indicatorEl}</section>;
}

const Action_Node = (props) => {
  const updateXarrow = useXarrow();
  const worflowData = useSelector((state) => state.workflowSetter);

  const [referenceElement, setReferenceElement] = React.useState(null);
  const [popperElement, setPopperElement] = React.useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "right-start",
    modifiers: [{ name: "flip", enabled: false }],
  });

  useEffect(() => {
    updateXarrow();

  }, []);

  // Actions
  const [{ action_isOver, result }, action_drop] = useDrop({
    accept: "action_card",
    drop: (item, monitor) => {
      get_metadata_info(item.id)
        .then((response) => {
          if (
            response.variables.length == 0 &&
            response.conditionSupported == false
          ) {
            //do a post call

            props.add_step(null, null, { isAction: true, id: item.id }, "");
          } else {
            if (props.trigger_nodes.length > 0) {
              updateXarrow();
              props.modal_props(true, true, item.id);
            } else {
              toast.info("Please add a trigger node");
            }
          }
        })
        .catch((e) => { })
    },
    collect: (monitor) => ({
      action_isOver: !!monitor.isOver(),
    }),
  });

  const handlenodeclick = () => {
    //Open modal
    get_step_data(worflowData.workflowId, props.id)
      .then((response) => {
        if (response.metadata.variables.length == 0) {

        } else {
          props.modal_props(
            true,
            true,
            props.action_data.metadata.id,
            props.source_id,
            props.conditional_node,
            props.path,
            props.action_data.metadata.subCategory,
            props.action_data.metadata.category,
            true,
            response.variables,
            response.conditions,
            props.id
          );
        }

        if (response.metadata.conditionSupported == true) {
          props.modal_props(
            true,
            true,
            props.action_data.metadata.id,
            props.source_id,
            props.conditional_node,
            props.path,
            props.action_data.metadata.subCategory,
            props.action_data.metadata.category,
            true,
            response.variables,
            response.conditions,
            props.id
          );
        }
      })
      .catch((e) => { })
  };
  return (
    <a>
      <div>
        {!props.action_data.isValid ? (
          props.action_data.error == null ? (
            <Portal>
              <style></style>
              <div
                class=" container  node_popup"
                ref={setPopperElement}
                style={styles.popper}
                {...attributes.popper}
              >
                <div className="d-flex" style={{ height: "100%" }}>
                  <div className="left_bar"></div>
                  <div class="container_icon">
                    <i
                      class="fas fa-exclamation-triangle"
                      style={{ color: "white !important" }}
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div class="container_info">{props.action_data.info}</div>
                  {/* <i class="far fa-times-circle" id="x5"></i> */}
                </div>
              </div>
            </Portal>
          ) : (
            <Portal>
              <div
                class=" container  node_popup"
                ref={setPopperElement}
                style={styles.popper}
                {...attributes.popper}
              >
                <div className="d-flex">
                  <div className="left_bar"></div>
                  <div class="container_icon">
                    <i
                      class="fas fa-exclamation-triangle"
                      style={{ color: "white !important" }}
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div class="container_info">{props.action_data.info}</div>
                  {/* <i class="far fa-times-circle" id="x5"></i> */}
                </div>
              </div>
            </Portal>
          )
        ) : (
          ""
        )}
        {props.name == "Wait" ? (
          <div className="circle" id={props.id} ref={setReferenceElement}>
            {props.action_data.targetA == null &&
              props.action_data.targetB == null ? (
              <i
                class="far fa-times-circle"
                id="x4"
                onClick={(e) => {
                  props.initial_action
                    ? toast.info("You cannot delete this action")
                    : props.handle_loading(true);
                  delete_step(worflowData.workflowId, props.id)
                    .then((data) => {

                      props.handlestepsResponse(data);
                      // props.handle_loading(false)
                    })
                    .catch((err) => {

                    });
                }}
              ></i>
            ) : (
              ""
            )}

            <div className="circle_content" onClick={handlenodeclick}>
              {!props.action_data.label ? " " : props.action_data.label}
            </div>
          </div>
        ) : props.name == "If/Else" ? (
          <div class="diamond" id={props.id} ref={setReferenceElement}>
            {props.action_data.targetA == null &&
              props.action_data.targetB == null ? (
              <i
                class="far fa-times-circle"
                id="x3"
                onClick={(e) => {
                  props.initial_action
                    ? toast.info("You cannot delete this action")
                    : props.handle_loading(true);
                  delete_step(worflowData.workflowId, props.id)
                    .then((data) => {

                      props.handlestepsResponse(data);
                      // props.handle_loading(false)
                    })
                    .catch((err) => {

                    });
                }}
              ></i>
            ) : (
              ""
            )}

            <div className="diamond_content" onClick={handlenodeclick}>
              {!props.action_data.label ? " " : props.action_data.label}
            </div>
          </div>
        ) : (
          <div
            className="card mb-3 kw_node_card"
            id={props.id}
            ref={setReferenceElement}
          >
            <div className="kw_node_card-header">
              {props.action_data.targetA == null &&
                props.action_data.targetA == null ? (
                <i
                  class="far fa-times-circle"
                  id="x"
                  onClick={(e) => {
                    props.initial_action
                      ? toast.info("You cannot delete this action")
                      : props.handle_loading(true);
                    delete_step(worflowData.workflowId, props.id)
                      .then((data) => {

                        props.handlestepsResponse(data);
                        // props.handle_loading(false)
                      })
                      .catch((err) => {

                      });
                  }}
                ></i>
              ) : (
                ""
              )}

              {props.action_data.metadata.name}
            </div>
            <div className="kw_node_card-body" style={{cursor: "pointer"}} onClick={handlenodeclick}>
              <div className="first-body-section">
                <h5 className="kw_node_card-title">
                  {props.action_data.label}
                </h5>
              </div>
            </div>
          </div>
        )}
      </div>
    </a>
  );
};

export default Action_Node;
